import getSeoBuyPage from 'services/api/Buy/seoBuyPages/getSeoBuyPage';

export default { getSeoBuyPage };
